import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=09b60713&scoped=true"
import script from "./DocumentRow.vue?vue&type=script&lang=js"
export * from "./DocumentRow.vue?vue&type=script&lang=js"
import style0 from "./DocumentRow.vue?vue&type=style&index=0&id=09b60713&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b60713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b60713')) {
      api.createRecord('09b60713', component.options)
    } else {
      api.reload('09b60713', component.options)
    }
    module.hot.accept("./DocumentRow.vue?vue&type=template&id=09b60713&scoped=true", function () {
      api.rerender('09b60713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/documentConfiguration/components/DocumentRow.vue"
export default component.exports